<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    required: false,
  },
  image: {
    type: String,
    required: false,
  },
  imageLight: {
    type: String,
    required: false,
  },
  imageDark: {
    type: String,
    required: false,
  },
  mediaImage: {
    type: String,
    required: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
  size: {
    type: Number,
    default: 22,
  },
  circle: {
    type: Boolean,
    default: false,
  },
  circleColor: {
    type: String,
    default: 'transparent',
  },
  alt: {
    type: String,
    default: '',
  },
});

const selectedAssetPath = computed(() => {
  if (props.imageLight || props.imageDark) {
    if (props.active && props.imageDark) {
      return props.imageDark;
    }
    if (props.imageLight) {
      return props.imageLight;
    }
  }
  return props.image || null;
});

const resolvedImageSrc = computed(() => {
  if (props.mediaImage) {
    return require(props.mediaImage);
  }
  if (!selectedAssetPath.value) {
    return null;
  }
  return require(`@/assets/icons/${selectedAssetPath.value}`);
});

const wrapperStyle = computed(() => ({
  '--nav-icon-size': `${props.size}px`,
  '--nav-icon-circle-size': `${props.size + 8}px`,
  '--nav-icon-circle-color': props.circleColor,
}));
</script>

<template>
  <span
    class="nav-icon-wrapper text-center"
    :class="{ 'nav-icon-wrapper-circle': circle, 'nav-icon-wrapper-active': active }"
    :style="wrapperStyle"
  >
    <i
      v-if="icon"
      class="nav-icon fa"
      :class="`fa-${icon}`"
    />
    <img
      v-else-if="resolvedImageSrc"
      class="img-fluid nav-icon"
      :src="resolvedImageSrc"
      :alt="alt"
    />
  </span>
</template>

<style scoped>
.nav-icon-wrapper {
  width: var(--nav-icon-circle-size);
  height: var(--nav-icon-circle-size);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.nav-icon-wrapper-circle {
  border-radius: 999px;
  background: var(--nav-icon-circle-color);
}

.nav-icon {
  width: var(--nav-icon-size);
  height: var(--nav-icon-size);
  font-size: calc(var(--nav-icon-size) * 0.8);
  transition: transform 180ms ease;
}

img.nav-icon {
  max-width: var(--nav-icon-size);
  height: auto;
}

.nav-icon-wrapper-active .nav-icon {
  transform: scale(1.22);
}
</style>
